import React, { PropTypes } from 'react';

import EventSearchName from '.';

import { clear, eventSearchContainer } from './styles.module.css';

const EventSearchNameContainer = ({
  events,
  clearQuery,
  handleChange,
  onEsc,
  onSelect,
  query,
  searchingByName,
  toggleField,
  total,
  ...props
}) => (
  <div className={eventSearchContainer}>
    <div className={clear} onClick={clearQuery}>Clear</div>
    <EventSearchName
      toggleField={toggleField}
      searchingByName={searchingByName}
      onEsc={onEsc}
      clearQuery={clearQuery}
      onChange={handleChange}
      onSelect={onSelect}
      value={query}
      events={events}
      total={total}
      {...props}
    />
  </div>
);

export default EventSearchNameContainer;

EventSearchNameContainer.propTypes = {
  /*
   * Function to close search on pressing ESC key.
   */
  onEsc: PropTypes.func,
  /*
   * Callback function when event is selected.
   */
  onSelect: PropTypes.func,
  /*
   * Clear input.
   */
  clearQuery: PropTypes.func,
  /*
   * Queries API on text change.
   */
  handleChange: PropTypes.func,
  /*
   * String query e.g. 'Cotswold Classic'.
   */
  query: PropTypes.string,
  /*
   * Array of events returned from API.
   */
  events: PropTypes.arrayOf(PropTypes.shape()),
  /*
   * Number of results that match user's query.
   */
  total: PropTypes.number,
  /**
   * Boolean to determine whether component is searching by name.
   */
  searchingByName: PropTypes.bool,
  /**
   * Function to toggle between name and type search.
   */
  toggleField: PropTypes.func,
};

EventSearchNameContainer.defaultProps = {
  onEsc: () => {},
  onSelect: () => {},
  clearQuery: () => {},
  handleChange: () => {},
  toggleField: () => {},
  query: undefined,
  events: undefined,
  total: undefined,
  searchingByName: false,
};



// WEBPACK FOOTER //
// ./app/src/components/EventSearchName/EventSearch.jsx